<template>
  <div class="p-16">
    <div class="w-full max-w-md mx-auto">
      <FormCreate ref="formCreate" :processing="creating" @submit="handleRoleCreation" />
    </div>
  </div>
</template>

<script>
import FormCreate from '@/components/Roles/FormCreate.vue';
import { roleMethods } from '@/store/adminHelper';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

export default {
  name: 'AdminRoleCreate',
  mixins: [veeValidateErrorsMixin],
  components: {
    FormCreate,
  },
  data: () => ({
    creating: false,
  }),
  methods: {
    ...roleMethods,
    handleRoleCreation(postData) {
      this.creating = true;
      this.storeRole({ postData })
        .then(({ roleId }) => {
          this.creating = false;
          this.redirectToRole(roleId);
        })
        .catch(({ errors = {} } = {}) => {
          this.observer = this.$refs.formCreate.$refs.observer;
          this.addServerErrors(errors);
          this.creating = false;
        });
    },
    redirectToRole(roleId) {
      this.$router.replace({ name: 'admin.roles.show', params: { roleId } });
    },
  },
};
</script>
